"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TriptychCard = void 0;

var _react = _interopRequireDefault(require("react"));

var _ResponsiveBox = require("../../ResponsiveBox");

var _Box = require("../../Box");

var _Flex = require("../../Flex");

var _Image = require("../../Image");

var _Text = require("../../Text");

var _TriptychCard = require("./TriptychCard");

var _excluded = ["images", "title", "subtitle", "status"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var TriptychCard = function TriptychCard(_ref) {
  var images = _ref.images,
      title = _ref.title,
      subtitle = _ref.subtitle,
      status = _ref.status,
      rest = _objectWithoutProperties(_ref, _excluded);

  var imgs = ((0, _TriptychCard.isArrayOfStrings)(images) ? images.map(function (src) {
    return {
      src: src
    };
  }) : images).slice(0, 3);
  return /*#__PURE__*/_react.default.createElement(_Box.Box, rest, /*#__PURE__*/_react.default.createElement(_ResponsiveBox.ResponsiveBox, {
    aspectWidth: 3,
    aspectHeight: 2,
    maxWidth: "100%",
    mb: 1
  }, /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    flexDirection: "row",
    width: "100%",
    height: "100%"
  }, function () {
    switch (imgs.length) {
      case 1:
        return /*#__PURE__*/_react.default.createElement(_ResponsiveBox.ResponsiveBox, {
          aspectWidth: 3,
          aspectHeight: 2,
          maxWidth: "100%",
          bg: "black10",
          borderRight: "1px solid",
          borderColor: "white100"
        }, /*#__PURE__*/_react.default.createElement(_Image.Image, _extends({
          alt: "",
          height: "100%",
          width: "100%",
          style: {
            objectFit: "cover"
          }
        }, imgs[0])));

      case 2:
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ResponsiveBox.ResponsiveBox, {
          aspectWidth: 1,
          aspectHeight: 1,
          maxWidth: "100%",
          bg: "black10",
          borderRight: "1px solid",
          borderColor: "white100"
        }, /*#__PURE__*/_react.default.createElement(_Image.Image, _extends({
          alt: "",
          height: "100%",
          width: "100%",
          style: {
            objectFit: "cover"
          }
        }, imgs[0]))), /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
          width: "33.33%",
          flexShrink: 0
        }, /*#__PURE__*/_react.default.createElement(_ResponsiveBox.ResponsiveBox, {
          aspectWidth: 1,
          aspectHeight: 2,
          maxWidth: "100%",
          bg: "black10",
          borderLeft: "1px solid",
          borderColor: "white100"
        }, /*#__PURE__*/_react.default.createElement(_Image.Image, _extends({
          alt: "",
          height: "100%",
          width: "100%",
          style: {
            objectFit: "cover"
          }
        }, imgs[1])))));

      case 3:
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ResponsiveBox.ResponsiveBox, {
          aspectWidth: 1,
          aspectHeight: 1,
          maxWidth: "100%",
          bg: "black10",
          borderRight: "1px solid",
          borderColor: "white100"
        }, /*#__PURE__*/_react.default.createElement(_Image.Image, _extends({
          alt: "",
          height: "100%",
          width: "100%",
          style: {
            objectFit: "cover"
          }
        }, imgs[0]))), /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
          width: "33.33%",
          flexShrink: 0,
          flexDirection: "column"
        }, /*#__PURE__*/_react.default.createElement(_ResponsiveBox.ResponsiveBox, {
          aspectWidth: 1,
          aspectHeight: 1,
          maxWidth: "100%",
          bg: "black10",
          borderLeft: "1px solid",
          borderBottom: "1px solid",
          borderColor: "white100"
        }, /*#__PURE__*/_react.default.createElement(_Image.Image, _extends({
          alt: "",
          height: "100%",
          width: "100%",
          style: {
            objectFit: "cover"
          }
        }, imgs[1]))), /*#__PURE__*/_react.default.createElement(_ResponsiveBox.ResponsiveBox, {
          aspectWidth: 1,
          aspectHeight: 1,
          maxWidth: "100%",
          bg: "black10",
          borderLeft: "1px solid",
          borderTop: "1px solid",
          borderColor: "white100"
        }, /*#__PURE__*/_react.default.createElement(_Image.Image, _extends({
          alt: "",
          height: "100%",
          width: "100%",
          style: {
            objectFit: "cover"
          }
        }, imgs[2])))));
    }
  }())), status && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "xs",
    textTransform: "uppercase"
  }, status), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "md"
  }, title), subtitle && /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "md",
    color: "black60"
  }, subtitle));
};

exports.TriptychCard = TriptychCard;
TriptychCard.displayName = "TriptychCard";